import { Container, Grid, Card, Paper, CardHeader, CardActions, CardContent } from '@mui/material';
import Iconify from "../../components/iconify/Iconify";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import RouteConstants from "../../configs/RouteConstants";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const reports = [
    { permission: "", path: RouteConstants.DAILY_FEE_COLLECTION, name: "Daily Fee Collections", icon: "cryptocurrency:usd", color: "#64a56f" },
    { permission: "", path: RouteConstants.OUTSTANDING_FEES, name: "Outstanding Fees", icon: "fa6-solid:pen-ruler", color: "#74b9db" }
];

const Reports = () => {
    return (
        <Container maxWidth="xll" >
            <Card>
                <CardHeader title="Reports" />
                <CardContent>
                    <Grid container spacing={2}>
                        {
                            reports.map((report) => {
                                return (

                                    <Grid item xs={12} sm={6} md={4} lg={3} style={{ justifyContent: "center", display: "flex" }}>
                                        <Link to={report.path}>
                                            <Item>
                                                <Card variant="outlined" sx={{ height: "10rem", width: "15rem", display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} style={{ backgroundColor: report.color }}>
                                                    <CardContent>
                                                        <Iconify icon={report.icon} width={50} />
                                                    </CardContent>
                                                    <CardActions>
                                                        <div style={{ fontSize: "larger", fontWeight: "bold" }}> {report.name} </div>
                                                    </CardActions>
                                                </Card>
                                            </Item>
                                        </Link>
                                    </Grid>

                                )
                            })
                        }
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    )
};

export default Reports;